import axios from "axios";
import { toast } from "react-toastify";
import * as Sentry from '@sentry/react';
import { createActionErrorCapture, errorEnvelope } from '../../../../utils/sentryUtils';
import { invoiceDetailsUrl, invoicePaginatedUrl, invoiceFileDownloadUrl } from "../urls";
import { getToken, getTokenHeader } from "../../../Common/Token";

const captureActionError = createActionErrorCapture('invoice');

export const getInvoicePaginatedAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(invoicePaginatedUrl(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    captureActionError(err, 'getInvoicePaginatedAction');
    return errorEnvelope(err, 'Something went wrong. Please try again.');
  }
};
export const downloadInvoiceFileAction = async (file_id, file_name, file_type) => {
  try {
    const token = await getToken();
    const response = await fetch(
      `${invoiceFileDownloadUrl()}/${file_id}?file_type=${file_type}`,
      { method: 'GET', ...getTokenHeader(token) }
    );
    if (!response.ok) {
      Sentry.captureException(new Error(`downloadInvoiceFileAction failed with status ${response.status}`), {
        tags: { module: 'invoice', flow: 'downloadInvoiceFileAction' },
        extra: { file_id, file_type, status: response.status },
      });
      toast.error('No Invoice File Found');
      return;
    }
    const blob = await response.blob();
    if (blob.type.includes('application/json')) {
      toast.error('No Invoice File Found');
      return;
    }
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.setAttribute('download', file_name);
    a.click();
    URL.revokeObjectURL(a.href);
  } catch (err) {
    Sentry.captureException(err, {
      tags: { module: 'invoice', flow: 'downloadInvoiceFileAction' },
      extra: { file_id, file_type },
    });
    toast.error('Failed to download file');
  }
};

export const getInvoiceDetailsAction = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    const token = await getToken();
    const { data } = await axios.get(invoiceDetailsUrl(), {
      params: params,
      ...getTokenHeader(token),
    });
    return data;
  } catch (err) {
    captureActionError(err, 'getInvoiceDetailsAction');
    return errorEnvelope(err, 'Something went wrong. Please try again.');
  }
};